import React, { useState, useEffect } from 'react';
import SelectList from '../selectList';
import SelectedList from '../selectedList';
import styles from './index.module.scss';
const SiriusContactIMModal = props => {
    const { onCancel, onSure, onChange, type = ['enterprise'], disableCheckList, searchType = 'enterprise', defaultSelectList, order, accountRootKey, showAddTeamBtn, useEdm, showAddOrgBtn = true, showFooter = false, excludeOrgTypes, } = props;
    const [needScrollBottom, setNeedScrollBottom] = useState(true);
    const [selectList, setSelectList] = useState([]);
    const handleDelete = (itemList, contactList) => {
        setSelectList(itemList);
        setNeedScrollBottom(false);
        onChange && onChange(itemList, contactList);
    };
    const handleSelect = (itemList, contactList) => {
        setSelectList(itemList);
        setNeedScrollBottom(true);
        onChange && onChange(itemList, contactList);
    };
    const handleCancel = () => {
        onCancel && onCancel(selectList);
    };
    const handleSure = (itemList) => {
        setSelectList(itemList);
        onSure && onSure(selectList);
    };
    useEffect(() => {
        if (defaultSelectList != null) {
            setSelectList(defaultSelectList);
        }
    }, [defaultSelectList]);
    return (React.createElement("div", { className: styles.wrap },
        React.createElement("div", { className: styles.bodyLeft },
            React.createElement(SelectList, { containerHeight: "100%", isIM: true, showNoDataPlaceholder: true, order: order, type: type, searchType: searchType, defaultSelectList: selectList, disableCheckList: disableCheckList, useEdm: useEdm, showAddTeamBtn: showAddTeamBtn, showAddOrgBtn: showAddOrgBtn, excludeOrgTypes: excludeOrgTypes, onSelect: handleSelect, accountRootKey: accountRootKey, noRelateEnterprise: true })),
        React.createElement("div", { className: styles.bodyRight },
            React.createElement(SelectedList, { selectList: selectList, onDelete: handleDelete, onCancel: handleCancel, onSure: handleSure, needScrollBottom: needScrollBottom, showFooter: showFooter, showPosition: false }))));
};
export default SiriusContactIMModal;
